/* Gift-first · Product rail — mobile snap-scroller arrows.
   The rail itself is CSS (scroll-snap); this only wires the two round
   prev/next buttons in the 390 comp. No dependencies. */
(function () {
  'use strict';

  function step(rail) {
    var card = rail.querySelector('.gf-product-rail__card');
    var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
    return card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
  }

  function setup(viewport) {
    if (viewport.dataset.gfRailReady === 'true') return;
    viewport.dataset.gfRailReady = 'true';

    var rail = viewport.querySelector('.gf-product-rail__rail');
    if (!rail) return;

    var prev = viewport.querySelector('[data-gf-rail-prev]');
    var next = viewport.querySelector('[data-gf-rail-next]');

    function move(dir) {
      // Respect a reduced-motion preference; re-read it on every click so a
      // mid-session change is honoured. An explicit behavior:'smooth' would
      // override the scroll-behavior:auto guard in gift-first.css.
      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: dir * step(rail), behavior: reduce ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('.gf-product-rail__viewport'),
      setup
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
